import React, { FC, useEffect } from 'react';

import isNil from 'lodash/isNil';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router';

import AgeCategorySelector from '../common/AgeCategorySelector';
import { changeLoanFormat } from '../../store/loanFormat/actions';
import { getLoanFormatFromForeignLanguageUrl } from '../utils/utils-url-to-loanformat';
import TitleDropdown from './TitleDropdown';
import LoanFormatDropDown from './LoanFormatDropDown';
import SubNavigationLayout from './SubNavigationLayout';
import { LinkContainer } from './NavigationLinksContainer';
import { AppDispatch } from '../../store';
import { LoanFormatState } from '../../store/loanFormat/state';
import { AppState } from '../../store/appState';
import { NavigationLink } from './NavigationLink';

import './ForeignLanguageNavigation.scss';
import { useTranslation } from 'react-i18next';

type Props = {
    readonly isSticky?: boolean;
};

const ForeignLanguageNavigation: FC<Props> = props => {
    const { isSticky } = props;
    const { t } = useTranslation();
    const dispatch = useDispatch<AppDispatch>();
    const location = useLocation();
    const loanFormat = useSelector(selectLoanFormat);

    // FIXME is is not the concern of this component to sync loan format changes to the state!
    useEffect(() => {
        const loanFormatFromUrl = getLoanFormatFromForeignLanguageUrl(location.pathname);
        if (!isNil(loanFormatFromUrl) && loanFormat.key !== loanFormatFromUrl.key) {
            dispatch(changeLoanFormat(loanFormatFromUrl));
        }
    });

    const loanFormatKey = loanFormat?.key ?? 'all';
    const lowerLoanFormat = loanFormatKey.toLowerCase();

    return (
        <SubNavigationLayout
            className="foreign-language-nav"
            left={<TitleDropdown isForeignLanguage={true} locationPathname={undefined} />}
            center={
                <LinkContainer>
                    <li>
                        <NavigationLink to={`/language/lote/${lowerLoanFormat}`} alternativeRoutes={['/language/lote']}>
                            {t('menu.shop.languages.lote')}
                        </NavigationLink>
                    </li>
                    <li>
                        <NavigationLink
                            to={`/language/languagelearning/${lowerLoanFormat}`}
                            alternativeRoutes={['/language/languagelearning']}
                        >
                            {t('menu.shop.languages.languageLearning')}
                        </NavigationLink>
                    </li>
                    <li>
                        <NavigationLink
                            to={`/language/bundles/${lowerLoanFormat}`}
                            alternativeRoutes={['/language/bundles']}
                        >
                            {t('menu.shop.languages.curatedCollections')}
                        </NavigationLink>
                    </li>
                </LinkContainer>
            }
            right={
                !isSticky && (
                    <div className="dropdown-container">
                        <LoanFormatDropDown showIcons={false} />
                        <AgeCategorySelector />
                    </div>
                )
            }
            isSticky={isSticky}
            width="30"
        />
    );
};

export default ForeignLanguageNavigation;

function selectLoanFormat(state: AppState): LoanFormatState {
    return state.loanFormat;
}
